.flexColumnContainer {
  display: flex;
  flex-direction: column;
  gap: var(--spacingSm);
}

.categoryContainer {
  display: flex;
  gap: var(--spacingSm);
}

.changesContainer {
  display: flex;
  gap: var(--spacingSm);
}

.singleChangeContainer {
  width: 100%;
}

.bookingPill {
  height: auto;
  border-radius: var(--radiusMd);
}

.bookingPillContent {
  display: flex;
  flex-direction: column;
  padding: var(--spacingSm);
}

.deleteBookingMessage {
  display: flex;
  flex-direction: column;
  gap: var(--spacingSm);
}
